var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0065 21.5H9.60546C6.02021 21.5 4.22759 21.5 3.11379 20.365C2 19.2301 2 17.4034 2 13.75C2 10.0966 2 8.26992 3.11379 7.13496C4.22759 6 6.02021 6 9.60546 6H13.4082C16.9934 6 18.7861 6 19.8999 7.13496C20.7568 8.00819 20.9544 9.2909 21 11.5",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.85 19.35L17.5 18.45V16.2M13 18C13 20.4853 15.0147 22.5 17.5 22.5C19.9853 22.5 22 20.4853 22 18C22 15.5147 19.9853 13.5 17.5 13.5C15.0147 13.5 13 15.5147 13 18Z",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6L15.9007 5.69094C15.4056 4.15089 15.1581 3.38087 14.5689 2.94043C13.9796 2.5 13.197 2.5 11.6316 2.5H11.3684C9.80304 2.5 9.02036 2.5 8.43111 2.94043C7.84186 3.38087 7.59436 4.15089 7.09934 5.69094L7 6",
    stroke: "#6D6D6D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkHistory);
export default __webpack_public_path__ + "static/media/work-history.3e450d6f05949dbec41eb71a73e7103a.svg";
export { ForwardRef as ReactComponent };